// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    add_own_options: 'Ajoutez vos propres options',
    allActivities: 'Tous les types d\'activité (tâche, problème, requête)',
    AllActivities_group_title: 'Tous les champs de types d\'activité (tâche, problème, requête)',
    customer: 'Client',
    Customer_group_title: 'Champs du client',
    default_field_name: 'Nouveau champ',
    delete_field_title: 'Supprimer le champ {0} ?',
    expense: 'Dépense',
    Expense_group_title: 'Champs de dépense',
    issue: 'Problème',
    Issue_group_title: 'Champs de problème',
    limitReachedMessage: 'Nous sommes désolés, vous avez atteint le nombre maximal de champs personnalisés que vous pouvez ajouter pour le type choisi.',
    msg_deleteUsedValue: 'Cette valeur est utilisée dans {0} {1}',
    msg_entities_portfolioRemoved: 'Ce champ ne sera plus disponible pour les entités incluses dans les portefeuilles exclus',
    msg_lead_to: 'Cette modification entraînera ce qui suit :',
    msg_restrictionsAdded: 'Ce champ personnalisé sera limité au portefeuille.',
    msg_restrictionsRemoved: 'Ce champ personnalisé ne sera plus limité au portefeuille.',
    msg_unportfolioedOff: 'Ce champ personnalisé ne sera pas disponible pour les projets non inclus dans les portefeuilles.',
    msg_valueRemoved: 'Les éléments de liste exclus de ce champ personnalisé seront supprimés.',
    portfolio: 'Portefeuille',
    Portfolio_group_title: 'Champs de portefeuille',
    project: 'Projet',
    Project_group_title: 'Champs de projet',
    request: 'Requête',
    Request_group_title: 'Champs de requête',
    select_from: 'Sélectionner un champ personnalisé',
    task: 'Tâche',
    Task_group_title: 'Champs de tâche',
    text_add: 'Ajouter',
    text_add_new_item: 'Ajoutez un nouvel élément ou utilisez Ctrl+V pour coller une liste d\'éléments',
    text_add_portfolio: 'Ajouter un portefeuille',
    text_addDescription: 'Ajouter une description',
    text_all_objects: 'Tous les objets',
    text_available_in: 'Portefeuilles pour le champ :',
    text_create_new_field: 'Créer un nouveau champ',
    text_currentIdentity: 'Seed',
    text_custom_field_for: 'Champ pour',
    text_delete: 'Supprimer le champ',
    text_delete_permanently: 'Supprimer définitivement',
    text_deleteValue: 'Supprimer la valeur',
    text_edit: 'Modifier le  champ',
    text_empty_page_part1: 'Avez-vous besoin de plus de flexibilité pour suivre et générer des rapports concernant vos données ?',
    text_empty_page_part2: 'Ajoutez vos propres champs pour les projets, tâches, utilisateurs et plus encore...',
    text_error_title: 'L\'opération n\'a pas pu être terminée.',
    text_fieldName: 'Nom du champ',
    text_fieldType: 'Type de champ :',
    text_filter: 'Champs personnalisés pour',
    text_include_in_unportfolioed_projects: 'Afficher également pour les projets non inclus dans les portefeuilles',
    text_isIdentity: 'Incrémenter auto',
    text_isNumeric: 'Ne pas montrer les décimales',
    text_isRequired: 'C\'est obligatoire',
    text_place_plural: '1#lieu#lieux',
    text_remainingValuesTemplate: 'afficher {0} éléments masqués en haut de la liste',
    text_remove: 'Supprimer',
    text_restricted_by_portfolio: 'Limiter par portefeuille',
    text_set_restrictions: 'Afficher ce champ uniquement pour les projets inclus dans les portefeuilles sélectionnés',
    timeEntry: 'Saisie de temps',
    TimeEntry_group_title: 'Champs de saisie de temps',
    use_cfs_options: 'Utiliser un champ personnalisé comme source d\'options',
    use_own_options: 'Utilisez vos propres options',
    user: 'Utilisateur',
    User_group_title: 'Champs d\'utilisateur',
};
